/**
 * Analytics produit — module UNIQUE (PostHog EU), même règles que GameTime :
 *  - AUCUN appel PostHog ailleurs dans le code.
 *  - No-op propre si REACT_APP_POSTHOG_KEY est absente.
 *  - identify() n'envoie QUE l'uid Firebase — jamais de nom, d'e-mail, d'année
 *    scolaire ni de résultat nominatif (public mineur).
 *
 * Liste FERMÉE des événements (à étendre dans DECISIONS.md, pas ici à la volée) :
 *  app_first_open, app_open, signup_completed, login_completed, profile_completed {role},
 *  chapter_opened, theory_viewed {level}, chat_message_sent {action}, exercise_answered
 *  {level, correct}, level_unlocked {level}, test_started, test_completed {score, passed},
 *  paywall_viewed {context}, subscribe_completed {plan}, streak_extended {days},
 *  account_linked {method}, account_deleted,
 *  parent_code_generated, parent_link_created (espace parents, sans propriété),
 *  review_completed {score, passed} (révision espacée), notifications_enabled {enabled},
 *  learning_profile_completed {skipped}, lesson_started {level}, lesson_completed {level, segments}
 *  (Phase 3b : profil d'apprentissage et cours du prof IA).
 */
import posthog from "posthog-js";

let enabled = false;
let pendingOpenSource: "direct" | "notification" = "direct";

export function initAnalytics(): void {
  if (enabled) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";
  if (!key) return;
  try {
    posthog.init(key, {
      api_host: host,
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      persistence: "localStorage",
      disable_session_recording: true,
    });
    enabled = true;
  } catch (e) {
    enabled = false;
  }
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (!enabled) return;
  try {
    posthog.capture(event, props || {});
  } catch (e) {
    /* l'analytics ne doit jamais casser le produit */
  }
}

export function identify(userId: string): void {
  if (!enabled || !userId) return;
  try {
    posthog.identify(userId);
  } catch (e) {
    /* silencieux */
  }
}

export function reset(): void {
  if (!enabled) return;
  try {
    posthog.reset();
  } catch (e) {
    /* silencieux */
  }
}

export function markOpenedFromNotification(): void {
  pendingOpenSource = "notification";
}

export function consumeOpenSource(): "direct" | "notification" {
  const s = pendingOpenSource;
  pendingOpenSource = "direct";
  return s;
}
